// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCI34eHia4mmbaMmCwN0ErhNHPx1DRDvmw",
  authDomain: "stock-market-3c803.firebaseapp.com",
  projectId: "stock-market-3c803",
  storageBucket: "stock-market-3c803.firebasestorage.app",
  messagingSenderId: "32789409079",
  appId: "1:32789409079:web:4dd272691d5eba713a7eb2",
  measurementId: "G-CWP7GR1WT9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);

export { auth, firestore };  // Exporting initialized services
